/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Help_Center__Payments_N_Refunds__DescriptionInputs */

const en_help_center__payments_n_refunds__description = /** @type {(inputs: Help_Center__Payments_N_Refunds__DescriptionInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Payment methods, refund policy, and billing questions`)
};

/**
* | output |
* | --- |
* | "Payment methods, refund policy, and billing questions" |
*
* @param {Help_Center__Payments_N_Refunds__DescriptionInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const help_center__payments_n_refunds__description = /** @type {((inputs?: Help_Center__Payments_N_Refunds__DescriptionInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Help_Center__Payments_N_Refunds__DescriptionInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_help_center__payments_n_refunds__description(inputs)
});